import { render, staticRenderFns } from "./DeletePartner.vue?vue&type=template&id=3b3f60ac"
import script from "./DeletePartner.vue?vue&type=script&lang=js"
export * from "./DeletePartner.vue?vue&type=script&lang=js"
import style0 from "./DeletePartner.vue?vue&type=style&index=0&id=3b3f60ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports